export const experienceCenterReducer = (state = { loading: false }, action) => {
  switch (action.type) {

    case "GET_EXPERIENCE_CENTER_LIST_REQUEST":
      return { ...state, loading: true, experienceCenters: null };

    case "GET_EXPERIENCE_CENTER_LIST_SUCCESS":
      return { ...state, loading: false, experienceCenters: action.payload };

    case "GET_EXPERIENCE_CENTER_LIST_FAILED":
      return { ...state, loading: false, experienceCenters: null, error: action.payload };

    case "GET_EXPERIENCE_CENTER_REQUEST":
      return { ...state, loading: true, experienceCenter: null };

    case "GET_EXPERIENCE_CENTER_SUCCESS":
      return { ...state, loading: false, experienceCenter: action.payload };

    case "GET_EXPERIENCE_CENTER_FAILED":
      return { ...state, loading: false, experienceCenter: null, error: action.payload };

    case "ADD_NEW_EXPERIENCE_CENTER_REQUEST":
      return { ...state, loading: true };

    case "ADD_NEW_EXPERIENCE_CENTER_SUCCESS":
      return { ...state, loading: false, lastAddedExperienceCenter: action.payload.data };

    case "ADD_NEW_EXPERIENCE_CENTER_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "UPDATE_EXPERIENCE_CENTER_REQUEST":
      return { ...state, loading: true };

    case "UPDATE_EXPERIENCE_CENTER_SUCCESS":
      return { ...state, loading: false, experienceCenter: action.payload };

    case "UPDATE_EXPERIENCE_CENTER_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "CHANGE_EXPERIENCE_CENTER_STATUS_REQUEST":
      return { ...state, loading: true };

    case "CHANGE_EXPERIENCE_CENTER_STATUS_SUCCESS":
      return { ...state, loading: false, experienceCenters: action.payload };

    case "CHANGE_EXPERIENCE_CENTER_STATUS_FAILED":
      return { ...state, loading: false, error: action.payload };

    // ─── Experience Center Form ───────────────────────────────────────

    case "GET_EXPERIENCE_CENTER_FORM_LIST_REQUEST":
      return { ...state, loading: true, experienceCenterForms: null };

    case "GET_EXPERIENCE_CENTER_FORM_LIST_SUCCESS":
      return { ...state, loading: false, experienceCenterForms: action.payload };

    case "GET_EXPERIENCE_CENTER_FORM_LIST_FAILED":
      return { ...state, loading: false, experienceCenterForms: null, error: action.payload };

    case "GET_EXPERIENCE_CENTER_FORM_REQUEST":
      return { ...state, loading: true, experienceCenterForm: null };

    case "GET_EXPERIENCE_CENTER_FORM_SUCCESS":
      return { ...state, loading: false, experienceCenterForm: action.payload };

    case "GET_EXPERIENCE_CENTER_FORM_FAILED":
      return { ...state, loading: false, experienceCenterForm: null, error: action.payload };

    case "CHANGE_EXPERIENCE_CENTER_FORM_STATUS_REQUEST":
      return { ...state, loading: true };

    case "CHANGE_EXPERIENCE_CENTER_FORM_STATUS_SUCCESS":
      return { ...state, loading: false, experienceCenterForms: action.payload };

    case "CHANGE_EXPERIENCE_CENTER_FORM_STATUS_FAILED":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};